import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function CierreProtectedRoute(props){
    return <PrivateRoute allowedroles={['administrator','recepcion']}>
        {props.children}
    </PrivateRoute>;
}